import React from "react";
import { connect } from 'react-redux'
import {
  SimpleAppBar,
  BasePaper,
  NavDrawer,
  BaseIcon,
  MasterLayout,
} from "@dclab/dc-react-ui-kit";
import { Switch, Route } from "react-router-dom";
import { ReactComponent as MoreApps } from "../../assets/nav_icons/moreapps.svg";
import { ReactComponent as Support } from "../../assets/nav_icons/support.svg";
import { ReactComponent as Launch } from '../../assets/nav_icons/launch-24px.svg'
import MainLogo from '../../assets/img/DC_Logo.png';
import { ChevronRight } from '@material-ui/icons';
import PrivateRoute from "../../components/PrivateRoute";


import CoursesListing from './Courses/CoursesListing';
import AddCourses from './Courses/AddCourses';
import CourseDetails from './Courses/CourseDetails';
import AddNewAnnouncement from './Courses/AddNewAnnouncement';
import AddAttendance from './Courses/AddAttendance';

import OrdersListing from './Orders/OrdersListing';
import Details from './Orders/Details';
import AddPayment from './Orders/AddPayment';

import StudentsListing from './Students/StudentsListing';
import DetailsPage from './Students/DetailsPage';

import Categories from './Categories/Categories';
import AddNewCategories from './Categories/AddNewCategories';

import Instructors from './Instructors/Instructors';
import AddNewInstructors from './Instructors/AddNewInstructors';

import Promotions from './Promotions/Promotions';
import AddNewCampaign from './Promotions/AddNewCampaign';



const headerItems = [
  {
    title: "Courses",
    path: "/education/courses-listing",
  },
  {
    title: "Orders",
    path: "/education/orders-listing",
  },

  {
    title: "Students",
    path: "/education/students",
  },

];

const bodyItems = {
  MANAGE: [
    {
      title: "Categories",
      path: "/education/categories",
      child: [
      ],
    },

    {
      title: 'Instructors',
      path: "/education/instructors",
      child: [],
      // badgeText: 'Coming Soon'
    },

    {
      title: 'Promo Code',
      path: "/education/promotions",
      child: [],
      // badgeText: 'Coming Soon'
    },

  ],

};

const footerItems = [
  {
    title: "More Apps",
    icon: <BaseIcon icon={MoreApps} />,
    path: "/more-apps",
    child: [
    ],
    secondaryIcon: <BaseIcon icon={ChevronRight} />,
  },
  {
    title: "Support",
    icon: <BaseIcon icon={Support} />,
    path: "http://shapla.deenconnect.io/support",
    child: [],
    secondaryIcon: <BaseIcon icon={Launch} />
  },
];
const Education = (props) => {
  function onClick() {
    props.history.push('/dashboard')
  }

  const returnActiveTab = () => {
    switch (props.match.path) {
      case '/deenfund/donations/details':
        return "Donations";
      default:
        return false;
    }
  };

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [props.location.pathname])
  const logout = () => {
    localStorage.setItem('user', false)
    localStorage.setItem('authToken', '')
    props.history.replace('/signin')
    localStorage.clear();
  }
  const userProfile = () => {
    props.history.push("/admin-profile")
  };
  const navigate = (x, y) => {
    if (x === 'Support') {
      window.location.href = (y)
    } else {
      props.history.push(y)
    }
  }
  const getInitials = () => {
    let nameArr = localStorage.getItem("name") || (props?.signup?.fullName ?? '');
    nameArr = nameArr.length > 0 ? nameArr?.trim()?.split(" ") : [];
    let initials;
    if (nameArr?.length > 1) {
      initials = nameArr[0][0] + nameArr[1][0];
    } else {
      initials = nameArr?.[0]?.[0] + nameArr[0]?.[1] ?? '';
    }
    return initials;
  }
  let image = localStorage.getItem("image");
  console.log("userImage", image)
  const content = (
    <React.Fragment>
      <MasterLayout
        header={
          <SimpleAppBar
            src={MainLogo}
            name={localStorage.getItem("name") || props.signup.fullName}
            role={localStorage.getItem("role")}
            showImg={image && image !== "undefined" ? true : false}
            img={image && image !== "undefined" ? image : ""}
            onClickLogout={() => logout()}
            onClickProfile={() => userProfile()}
            initials={getInitials()}
            style={{ marginTop: 80, marginLeft: -10 }}
          />
        }
        sideBar={
          <NavDrawer
            headerNavItems={headerItems}
            bodyNavItems={bodyItems}
            footerNavItems={footerItems}
            onBackBtnClick={() => onClick()}
            onClick={() => console.log('')}
            buttonShow={true}
            showTitle={true}
            showBodyItem={true}
            activeTab={returnActiveTab()}
            navigate={(x, y) => navigate(x, y)}
            selectedTitle={'Education'}
            footerLower="footerLower"
          />
        }
        headerFixed={true}
        middleContent={
          <Switch>
            <PrivateRoute exact path="/education/courses-listing" component={CoursesListing} />
            <PrivateRoute exact path="/education/add-courses" component={AddCourses} />
            <PrivateRoute exact path="/education/course-details" component={CourseDetails} />
            <PrivateRoute exact path="/education/add-new-announcement" component={AddNewAnnouncement} />
            <PrivateRoute exact path="/education/add-attendance" component={AddAttendance} />
            <PrivateRoute exact path="/education/orders-listing" component={OrdersListing} />
            <PrivateRoute exact path="/education/order-details" component={Details} />
            <PrivateRoute exact path="/education/add-payment" component={AddPayment} />
            <PrivateRoute exact path="/education/students" component={StudentsListing} />
            <PrivateRoute exact path="/education/student-details" component={DetailsPage} />
            <PrivateRoute exact path="/education/categories" component={Categories} />
            <PrivateRoute exact path="/education/categories/add-new-categories" component={AddNewCategories} />
            <PrivateRoute exact path="/education/instructors" component={Instructors} />
            <PrivateRoute exact path="/education/instructors/add-new-instructors" component={AddNewInstructors} />
            <PrivateRoute exact path="/education/promotions" component={Promotions} />
            <PrivateRoute exact path="/education/promotions/add-new-campaign" component={AddNewCampaign} />




          </Switch>
        }
      />
    </React.Fragment>
  );
  return (
    <>
      <BasePaper elevation={0} context={content} />
    </>
  );
};
const mapStateToProps = state => {
  return {
    signup: state.signup
  }
}
export default connect(mapStateToProps, {})(Education);
